import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/utils/Button";
import CardLayout from "../../components/utils/CardLayout";
const SingleRecharge = () => {
  const [priceSummary, setPriceSummary] = useState({
    planCost: 30,
    quantity: 1,
    unitCost: 30,
    totalDealerCost: 30,
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      plan: "",
      month: "",
      msisdn: "",
    },
  });

  const onSubmit = (data) => {
    console.log("Recharge Data", data);

    // Call Recharge API here
  };

  const handleReset = () => {
    reset();

    setPriceSummary({
      planCost: 0,
      quantity: 1,
      unitCost: 0,
      totalDealerCost: 0,
    });
  };

  return (
      <CardLayout title="Recharge Details" icon="ri-flashlight-line fs-5">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            {/* Left */}
            <div className="col-lg-6">
              <div className="row">
                {/* Plan */}
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-semibold">
                    Plan <span className="text-danger">*</span>
                  </label>

                  <select
                    className="form-control"
                    {...register("plan", {
                      required: "Please select plan",
                    })}
                  >
                    <option value="">Select Plan</option>
                    <option value="1">Unlimited 30 Days</option>
                    <option value="2">Unlimited 60 Days</option>
                  </select>

                  {errors.plan && (
                    <small className="text-danger">{errors.plan.message}</small>
                  )}
                </div>

                {/* Month */}

                <div className="col-md-6 mb-2">
                  <label className="form-label fw-semibold">Month</label>

                  <select className="form-control" {...register("month")}>
                    <option value="">Select Month</option>
                    <option value="1">1 Month</option>
                    <option value="2">2 Month</option>
                    <option value="3">3 Month</option>
                  </select>
                </div>

                {/* MSISDN */}

                <div className="col-12 mb-4">
                  <label className="form-label fw-semibold">
                    MSISDN <span className="text-danger">*</span>
                  </label>

                  <input
                    className="form-control"
                    placeholder="Enter Mobile Number"
                    {...register("msisdn", {
                      required: "Enter mobile number",
                      pattern: {
                        value: /^[0-9]{10,15}$/,
                        message: "Invalid mobile number",
                      },
                    })}
                  />

                  {errors.msisdn && (
                    <small className="text-danger">
                      {errors.msisdn.message}
                    </small>
                  )}
                </div>

                {/* Buttons */}

                <div className="col-12 d-flex gap-3">
                  <Button
                    title="Recharge"
                    buttonType="submit"
                    variant="primary"
                    icon={<i className="ri-flashlight-line me-2"></i>}
                    style={{ width: "50%" }}
                  />

                  <Button
                    title="Reset"
                    buttonType="button"
                    variant="secondary"
                    onClick={handleReset}
                    icon={<i className="ri-refresh-line me-2"></i>}
                    style={{ width: "50%" }}
                  />
                </div>
              </div>
            </div>

            {/* Right Price Summary */}

            <div className="col-lg-6 mt-4 mt-lg-0">
              <div
                className="rounded-4 overflow-hidden h-100"
                style={{
                  border: "1px solid #e7dcea",
                  boxShadow: "0 8px 25px rgba(0,0,0,0.05)",
                  background: "#fff",
                }}
              >
                {/* Header */}
                <div
                  className="d-flex align-items-center gap-2 px-4 py-2"
                  style={{
                    background: "linear-gradient(90deg,#6F1D78,#4A0D5D)",
                    color: "#fff",
                  }}
                >
                  <i className="ri-wallet-3-line fs-5"></i>
                  <h6 className="mb-0  fw-bold">Price Summary</h6>
                </div>

                <div className="px-4 py-2">
                  {/* Plan Cost */}
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <span className="text-muted">Plan Cost</span>

                    <h5 className="mb-0 fw-bold text-dark">
                      ${priceSummary.planCost}
                    </h5>
                  </div>

                  <hr />

                  {/* Qty + Dealer Cost */}

                  <div className="row g-3 align-items-center">
                    <div className="col-5">
                      <div
                        className="text-center rounded-3 p-3"
                        style={{
                          background: "#F7ECFA",
                          border: "1px solid #EDD9F3",
                        }}
                      >
                        <small
                          className="d-block text-uppercase fw-semibold"
                          style={{ color: "#7a3f86" }}
                        >
                          Qty
                        </small>

                        <h3 className="fw-bold mt-2 mb-0">
                          {priceSummary.quantity}
                        </h3>
                      </div>
                    </div>

                    <div className="col-2 text-center">
                      <h4 className="mb-0 fw-bold" style={{ color: "#8E0E9D" }}>
                        ×
                      </h4>
                    </div>

                    <div className="col-5">
                      <div
                        className="text-center rounded-3 p-3"
                        style={{
                          background: "#F7ECFA",
                          border: "1px solid #EDD9F3",
                        }}
                      >
                        <small
                          className="d-block text-uppercase fw-semibold"
                          style={{ color: "#7a3f86", fontSize: 11 }}
                        >
                          Dealer Cost
                        </small>

                        <h4 className="fw-bold mt-2 mb-0">
                          ${priceSummary.unitCost}
                        </h4>
                      </div>
                    </div>
                  </div>

                  {/* Total */}

                  <div
                    className="rounded-3 text-center mt-4 py-4"
                    style={{
                      background: "linear-gradient(135deg,#1F6D2E,#0F4E1F)",
                      color: "#fff",
                      boxShadow: "0 8px 18px rgba(31,109,46,.25)",
                    }}
                  >
                    <small
                      className="text-white d-block mb-2"
                      style={{
                        letterSpacing: "1px",
                        color: "#fff",
                      }}
                    >
                      Total Dealer Cost
                    </small>

                    <h4 className="mb-0 fw-bold">
                      ${priceSummary.totalDealerCost}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </CardLayout>
  );
};
export default SingleRecharge;
